import React from "react";
import { string } from "prop-types";
import { classes } from "../utils/classes";
import { Col } from "../Grid";
import { spacingClassName, spacingProps } from "../props/spacing";

export const TabCol = ({ className, cell = "", spacing = { ...spacingProps }, ...props }) => (
	<Col
		className={classes(cell, ...spacingClassName(spacing), className)}
		{...props}
		role="presentation"
	/>
);

TabCol.propTypes = {
	cell: string,
	...Col.propTypes,
};
